// React Dependencies
import React, { Component, createRef } from 'react';

// External Dependencies
import _ from 'lodash';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Button, DialogTitle, DialogContent, DialogContentText, DialogActions, Dialog, Chip, Typography } from '@material-ui/core';
import { DropzoneArea } from 'material-ui-dropzone';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import Lightbox from 'react-image-lightbox';

// Internal Dependencies
import SortableMedia from '../../global/SortableMedia/SortableMedia';
import FixedCropper from '../../global/image/FixedCropper';
import OverLoading from '../../global/OverLoading';
import { convertDataURLtoBlob } from '../../../common/util';
import Constants from '../../../common/constants';
import { IsEmpty } from '../../../common/checks';
import 'react-image-lightbox/style.css';
import apiService from '../../../services.js/apiService';
import { handleError } from '../../../common/helpers';

const useStyles = () => ({
  myDropZone: {
    position:        'relative',
    width:           '50%',
    height:          '15%',
    minHeight:       '100px',
    backgroundColor: '#ffffff',
    border:          0,
    boxShadow:       '0px 0px 1px 0px rgba(0, 0, 0, 1)',
    borderRadius:    5,
    borderColor:     '#000000',
    cursor:          'pointer',
    boxSizing:       'border-box',
  },
});
class Photo extends Component {
  constructor(props) {
    super(props);
    this.selectCategoryRef = null;
    this.dropZoneRef = null;
    this.ref = createRef();
    this.state = {
      mediaData:         '',
      alert:             false,
      openCropDialog:    false,
      openCropDialogs:   {},
      originalFile:      null,
      originalFiles:     {},
      currentFile:       null,
      src:               null,
      listOfSrc:         {},
      listOfOrignalFile: {},
      type:              null,
      uploadUrl:         '',
      uploadUrls:        {},
      base64:            '',
      images:            [],
      view:              false,
      viewImage:         '',
      cropping:          false,
      tempImgToDelete:   [],
      isImagePosChanged: false,
      listOfFileImages:  [],
      imageDialogs:      {},
      currentFiles:      {},

      loading:                 false,
      currentImageSetToUpdate: null,
      pdfLinkFromCroppedImage: null,
    };

    // Unit in bytes
    this.maxFileSize = 7340032;
    this.maxPDFFileSize = 15728640;

    this.imageFormats = ['image/jpeg', 'image/jpg', 'image/png'];
    this.docFormats = ['application/pdf'];
    this.handleSaveMultiple = this.handleSaveMultiple.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.getBase64Image = this.getBase64Image.bind(this);
    this.handleView = this.handleView.bind(this);
    this.handleCrop = this.handleCrop.bind(this);

    this.handleChange = this.handleChange.bind(this);
    this.hiddenFileInput = createRef(null);

    this.handleUploadMultipleFile = this.handleUploadMultipleFile.bind(this);
  }

  fetchPost = async () => {
    try {
      const post = await apiService.getPostById(this.props.match.params.postId);
      if (post) {
        this.setState({ images: post.images });
      }
    } catch (error) {
      toast.error(error);
    }
  };

  componentDidMount() {
    if (!IsEmpty(this.props.images)) {
      this.setState({ images: this.props.images });
    } else {
      this.fetchPost();
    }
  }

  componentDidUpdate(prefProps, prevState) {
    if (this.state.images !== prevState.images) {
      this.ref.current = prevState.images;
    }
  }

  b64toBlob = (dataURI) => {
    const byteString = atob(dataURI.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i += 1) { ia[i] = byteString.charCodeAt(i); }

    return new Blob([ab], { type: 'image/jpeg' });
  }

  handleCrop = async (image) => {
    // openCropDialogs is used to hold the value of opening or closing each cropper dialog
    const newOpenCropDialogs = _.cloneDeep(this.state.openCropDialogs);

    // uploadUrls is used to hold the value of each uploadUrl
    const newUploadUrls = _.cloneDeep(this.state.uploadUrls);

    // Get all of the image post
    const { images } = this.state;

    // Get the index of the selected photo
    const imageIndex = images.findIndex((item) => item.original === image.original);

    // Slice array images to start from the image index
    const slicedArray = imageIndex === 0 ? images : images.slice(imageIndex);

    const temp = [];
    const newListOfSrc = {};
    const newOriginalFiles = {};
    for (let i = 0; i < slicedArray.length; i += 1) {
      const file = slicedArray[i];
      const dialogKey = `file${i}`;
      // Create a new open crop dialogs (open up a new modal for each individual image)
      newOpenCropDialogs[dialogKey] = true;

      // Assign a original file to upload url
      newUploadUrls[dialogKey] = file.original;

      temp.push(file);

      try {
        const imgUrl = newUploadUrls[dialogKey];
        if (!IsEmpty(imgUrl)) {
          newOriginalFiles[dialogKey] = await this.urlToFile(imgUrl);
          newListOfSrc[dialogKey] = await this.fileToBase64(newOriginalFiles[dialogKey]);
        }
      } catch (error) {
        toast.error(`Image number ${images.findIndex((imageObject) => imageObject === file) + 1} failed to load.`);
      }
    }

    this.setState({
      openCropDialogs: newOpenCropDialogs,
      uploadUrls:      newUploadUrls,
      cropping:        true,
      tempImgToDelete: temp,
      listOfSrc:       newListOfSrc,
      originalFiles:   newOriginalFiles,
      type:            'url',
      currentFile:     null,
    });
  }

  handleUploadUrl = () => {
    this.getBase64Image(this.state.uploadUrl, (base64image) => {
      this.setState({ openCropDialog: true, base64: base64image, type: 'url', currentFile: null },
        () => {
          const imgFile = this.b64toBlob(`data:image/*;base64,${this.state.base64}`);
          this.setState({ src: `data:image/*;base64,${this.state.base64}`, originalFile: new File([imgFile], 'o.jpeg', { type: 'image/jpeg' }) });
        });
    });
  }

  handleUploadMultipleFile = async (files) => {
    const newImageDialogs = { ...this.state.imageDialogs };
    const newCurrentFiles = { ...this.state.currentFiles };

    [...files].forEach((file, i) => {
      // Create a new image dialogs (open up a new modal for each individual file)
      newImageDialogs[`file${i}`] = true;
      // Add new files to display in the modal
      newCurrentFiles[`file${i}`] = file;

      const reader = new FileReader();
      reader.addEventListener('load', () => {
        this.setState((prevState) => {
          const newListOfSrc = { ...prevState.listOfSrc };
          // Added to listOfSrc to be used in the cropper
          newListOfSrc[`file${i}`] = reader.result;
          return { listOfSrc: newListOfSrc };
        });

        const originalImageBlob = convertDataURLtoBlob(reader.result);

        this.setState((prevState) => {
          const newListOfOrignalFile = { ...prevState.listOfOrignalFile };
          // Added to listOfOriginalFile because the original file will be saved when calling the API
          newListOfOrignalFile[`file${i}`] = new File([originalImageBlob], 'o.jpeg', { type: 'image/jpeg' });
          return { listOfOrignalFile: newListOfOrignalFile };
        });
      });
      reader.readAsDataURL(file);
    });

    // Updating the imageDialogs state
    this.setState({ imageDialogs: newImageDialogs });

    // Updating the listOfFileImages state
    this.setState((prevState) => {
      const newListOfFileImages = [...prevState.listOfFileImages, ...files];
      return { listOfFileImages: newListOfFileImages };
    });
  }

  handleUpload = (file) => {
    if (file.length > 0) {
      if (file.length === 1) {
        this.setState({
          openCropDialog: true,
          type:           'upload',
          originalFiles:  {},
        }, () => {
          if (this.state.openCropDialog) {
            this.setState({ currentFile: file[0] }, () => {
              const reader = new FileReader();
              reader.addEventListener('load', () => {
                this.setState({ src: reader.result });
                const originalImageBlob = convertDataURLtoBlob(reader.result);
                this.setState({ originalFile: new File([originalImageBlob], 'o.jpeg', { type: 'image/jpeg' }) });
              });
              reader.readAsDataURL(this.state.currentFile);
            });
          }
        });
        this.dropZoneRef.updater.enqueueSetState(this.dropZoneRef, { fileObjects: [] });
      } else {
        this.dropZoneRef.updater.enqueueSetState(this.dropZoneRef, { fileObjects: [] });
        this.handleUploadMultipleFile(file);
      }
    }
  }

  handleChange = (data) => {
    if (!IsEmpty(data)) {
      this.setState({ currentImageSetToUpdate: data }, () => this.hiddenFileInput.current.click());
    }
  }

  handlePDFUpload = async (e) => {
    try {
      this.setState({ loading: true });

      if (!IsEmpty(e.target.files)) {
        const validate = this.handleErrorMessage(e.target.files[0], 'pdf');
        if (validate) {
          const formData = new FormData();
          const file = e.target.files[0];

          formData.append('image', file);
          formData.append('type', 'pdf');
          formData.append('pageId', this.props.match.params.pageId);
          formData.append('original', this.state.currentImageSetToUpdate.original);

          const result = await apiService.uploadPostMedia(this.props.match.params.postId, formData, file);

          if (result) {
            const post = await apiService.getPostById(this.props.match.params.postId);
            if (post) {
              this.setState({
                images:  post.images,
                loading: false,
              }, () => {
                toast.success('PDF uploaded successfully');
                this.props.onSetPostImages(this.state.images);
              });
            }
          }
        } else {
          this.setState({ loading: false });
        }
      }
    } catch (error) {
      this.setState({ loading: false });
      toast.error(error);
    }
  }

  // Utility function to convert callback-based getBase64Image to a Promise-based function
  getBase64ImageAsync = (imgUrl) => new Promise((resolve, reject) => {
    this.getBase64Image(imgUrl, (base64image) => {
      if (base64image) {
        resolve(base64image);
      } else {
        reject(new Error('Failed to convert image to base64'));
      }
    });
  })

  getBase64Image = (imgUrl, callback) => {
    try {
      const img = new Image();
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // eslint-disable-next-line func-names
      img.onload = function () {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        let dataURL = canvas.toDataURL('image/png');
        dataURL = dataURL.replace(/^data:image\/(png|jpg|jpeg);base64,/, '');
        callback(dataURL); // the base64 string
      };

      img.onerror = function () {
        console.error(`Error: Failed to load image from URL: ${imgUrl}`);
        callback(null);
      };

      if (img.complete) {
        img.crossOrigin = Constants.CrossOrigin;
        img.src = imgUrl;
      }
    } catch (err) {
      callback(null);
    }
  };

  fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  })

  urlToFile = async (imgUrl) => {
    try {
      const response = await fetch(imgUrl, {
        method: 'GET',
        cache:  'no-cache', // Prevent caching issues
      });

      if (!response.ok) {
        return null;
      }

      const blob = await response.blob();
      const file = new File([blob], `o.${blob.type.split('/').at(-1)}`, { type: blob.type });

      return file;
    } catch (error) {
      console.error('Error fetching image:', error);
      return null;
    }
  }

  handleSaveMultiple = async (file, i = 0) => {
    try {
      if (file) {
        const formData = new FormData();
        formData.append('image', file);
        formData.append('image', this.state.listOfOrignalFile[`file${i}`]);
        formData.append('type', 'images');
        formData.append('pdfLinkFromCroppedImage', null);
        formData.append('pageId', this.props.match.params.pageId);

        const result = await apiService.uploadPostMedia(this.props.match.params.postId, formData, file);

        if (result) {
          this.setState((prevState) => {
            const newImageDialogs = { ...prevState.imageDialogs };
            const newListOfSrc = { ...prevState.listOfSrc };
            const newListOfOriginalFile = { ...prevState.listOfOrignalFile };
            const newListOfFileImages = prevState.listOfFileImages.filter((item, index) => (index !== (i !== undefined ? i : 0)));

            delete newImageDialogs[`file${i}`];
            delete newListOfSrc[`file${i}`];

            return {
              images:            this.state.images.concat(result),
              imageDialogs:      newImageDialogs,
              listOfSrc:         newListOfSrc,
              listOfOrignalFile: newListOfOriginalFile,
              listOfFileImages:  newListOfFileImages,
            };
          });

          this.setState({
            images:         this.state.images.concat(result),
            openCropDialog: false,
            cropping:       false,
            currentFile:    null,
            src:            null,
            type:           null,
            uploadUrl:      '',
            base64:         '',
          }, () => {
            this.props.onSetPostImages(this.state.images);
            toast.success('Image uploaded successfully.');
          });
        }
      }
      this.dropZoneRef.updater.enqueueSetState(this.dropZoneRef, { fileObjects: [] });
    } catch (err) {
      this.setState({
        openCropDialog: false,
        cropping:       false,
        currentFile:    null,
        src:            null,
        type:           null,
        uploadUrl:      '',
        base64:         '',
      });
      toast.error(err);
    }
  }

  handleSave = async (file, i = 0) => {
    try {
      this.setState({ loading: true });
      const dialogKey = `file${i}`;
      if (file) {
        const tempPostImages = this.state.images;

        const formData = new FormData();
        formData.append('image', file);
        formData.append('image', Object.keys(this.state.originalFiles).length > 0 ? this.state.originalFiles[dialogKey] : this.state.originalFile);
        formData.append('type', 'images');
        formData.append('pdfLinkFromCroppedImage', null);
        formData.append('pageId', this.props.match.params.pageId);

        if (this.state.cropping === true && this.state.tempImgToDelete.length > 0) {
          if (!IsEmpty(this.state.tempImgToDelete[i].originalFile)) {
            const index = this.state.images.findIndex((image) => image.originalFile && (this.state.tempImgToDelete[0].originalFile === image.originalFile));
            const finalArrayOfImages = this.state.images;

            formData.set('pdfLinkFromCroppedImage', this.state.pdfLinkFromCroppedImage);
            formData.append('imgIndex', index);
            const result = await apiService.uploadPostMedia(this.props.match.params.postId, formData, file);

            finalArrayOfImages.splice(index, 1, result);

            if (result) {
              const post = await apiService.getPostById(this.props.match.params.postId);
              if (post) {
                this.setState({
                  images:                  finalArrayOfImages,
                  openCropDialog:          false,
                  cropping:                false,
                  currentFile:             null,
                  src:                     null,
                  type:                    null,
                  uploadUrl:               '',
                  base64:                  '',
                  pdfLinkFromCroppedImage: null,
                }, () => {
                  this.props.onSetPostImages(this.state.images);
                });
              }
            }
          } else {
            const croppedImg = this.state.tempImgToDelete[i];

            formData.set('pdfLinkFromCroppedImage', this.state.pdfLinkFromCroppedImage);
            formData.append('original', croppedImg.original);

            const result = await apiService.uploadPostMedia(this.props.match.params.postId, formData, file);

            if (!IsEmpty(result)) {
              const updatedImages = _.map(
                tempPostImages,
                (img) => (img.original === croppedImg.original ? result : img),
              );

              const isLastImage = (i === this.state.images.length - 1);

              this.setState((prevState) => ({
                openCropDialogs: {
                  ...prevState.openCropDialogs,
                  [dialogKey]: false,
                },
                listOfSrc: {
                  ...prevState.listOfSrc,
                  [dialogKey]: '',
                },
                uploadUrls: {
                  ...prevState.uploadUrls,
                  [dialogKey]: '',
                },
                originalFiles: {
                  ...prevState.originalFiles,
                  [dialogKey]: null,
                },
                images:      updatedImages,
                currentFile: null,
                src:         null,
                type:        null,
                uploadUrl:   '',
                base64:      '',
                loading:     false,
                cropping:    !isLastImage,
              }), () => this.props.onSetPostImages(updatedImages));
            }
          }
          toast.success('Image cropped successfully.');
        } else {
          const result = await apiService.uploadPostMedia(this.props.match.params.postId, formData, file);
          if (result) {
            this.setState({
              images:         this.state.images.concat(result),
              openCropDialog: false,
              cropping:       false,
              currentFile:    null,
              src:            null,
              type:           null,
              uploadUrl:      '',
              base64:         '',
            }, () => {
              this.props.onSetPostImages(this.state.images);
              toast.success('Image uploaded successfully.');
            });
          }
        }
      }
    } catch (err) {
      this.setState({
        openCropDialogs: {},
        listOfSrc:       {},
        uploadUrls:      {},
        originalFiles:   {},
        cropping:        false,
        currentFile:     null,
        src:             null,
        type:            null,
        uploadUrl:       '',
        base64:          '',
        loading:         false,
      });
      toast.error(err.message);
    } finally {
      this.setState({ loading: false });
    }
  }

  handleDeletePdf = async (imageSet) => {
    try {
      this.setState({ loading: true });

      if (!IsEmpty(imageSet)) {
        const params = {
          id:        this.props.match.params.postId,
          pageId:    this.props.match.params.pageId,
          mediaData: imageSet,
          fileType:  Constants.FileType.Application,
        };

        await apiService.deletePostMedia(this.props.match.params.postId, params);
        const post = await apiService.getPostById(this.props.match.params.postId);
        if (post) {
          this.setState({
            images:  post.images,
            loading: false,
          }, () => {
            this.props.onSetPostImages(this.state.images);
            toast.success('PDF deleted');
          });
        }
      }
    } catch (err) {
      this.setState({ loading: false });
      toast.error(err.message);
    }
  }

  handleDelete = async (index) => {
    try {
      if (!IsEmpty(this.state.mediaData.originalFile)) {
        const index = this.state.images.findIndex((image) => image.originalFile && (this.state.mediaData.originalFile === image.originalFile));
        const finalArrayOfImages = this.state.images.filter((_, i) => i !== index);
        this.setState({
          images: finalArrayOfImages,
          alert:  false,
        });

        return;
      }

      let tempImgToDeleteData = this.state.mediaData;
      if (this.state.cropping === true && this.state.tempImgToDelete.length > 0) {
        tempImgToDeleteData = { ...this.state.tempImgToDelete[index], pdf: null };

        this.setState({ pdfLinkFromCroppedImage: this.state.tempImgToDelete[index].pdf }, () => {
          this.setState({ mediaData: tempImgToDeleteData });
        });
      }

      const params = {
        id:        this.props.match.params.postId,
        pageId:    this.props.match.params.pageId,
        mediaData: tempImgToDeleteData,
        fileType:  Constants.FileType.Image,
      };
      this.setState({ loading: true });
      const response = await apiService.deletePostMedia(this.props.match.params.postId, params);
      if (response) {
        const images = this.state.images.filter((image) => {
          if (image.display) {
            return image.display !== this.state.mediaData.display;
          } else {
            return image.original !== this.state.mediaData.original;
          }
        });
        this.setState({
          images,
          alert: false,
        },
          () => {
            this.props.onSetPostImages(this.state.images);
          });

        toast.success('Image successfully deleted.');

        return images;
      } else {
        this.setState({ alert: false });
        toast.error('An unexpected error has occurred');
      }
    } catch (err) {
      this.setState({ alert: false });
      toast.error(err.message);
    } finally {
      this.setState({ loading: false });
    }
  }

  handleConfirmation = (mediaData) => {
    this.setState({ alert: true, mediaData });
  }

  handleClose = () => {
    this.setState({ openCropDialog: false, currentFile: null, alert: false, base64: '', view: false, type: null, uploadUrl: '', cropping: false, tempImgToDelete: [] });
  }

  handleCloseImageDialogs = (index, name) => {
    this.setState((prevState) => ({
      listOfFileImages: prevState.listOfFileImages.filter((file) => file.name !== name),
    }));

    this.setState((prevState) => {
      // Destructure the imageDialogs state to get all keys except the one to be removed
      const { [index]: removedKey, ...newImageDialogs } = prevState.imageDialogs;
      return { imageDialogs: newImageDialogs };
    });
  }

  handleCloseOpenCropDialogs = () => {
    this.setState((prevState) => ({
      openCropDialogs: {},
      listOfSrc:       {},
      uploadUrls:      {},
      originalFiles:   {},
      cropping:        false,
    }));
  }

  handleSort = (images) => {
    this.setState({ loading: true, images, isImagePosChanged: true }, () => {
      this.props.onSort(images);
      this.handleUpdate();
    });
  }

  handleView = (image) => {
    let viewImage = image.original;

    if (typeof image.originalFile === 'object') {
      viewImage = URL.createObjectURL(image.originalFile);
    }

    this.setState({ view: true, viewImage });
  }

  handleUpdate = async () => {
    try {
      const payload = {
        images: this.state.images,
        pageId: parseInt(this.props.match.params.pageId, 10),
      };
      await apiService.updatePost(this.props.match.params.postId, payload);
      this.setState({ isImagePosChanged: false, loading: false }, () => toast.success('Image position updated'));
    } catch (err) {
      handleError(
        err,
        'Error in Post.promo.photos.handleUpdate()',
        { additionalData: { postId: this.props.match.params.postId } },
      );
      this.setState({ images: this.ref.current, loading: false });
    }
  }

  handleErrorMessage = (file, format) => {
    if (!IsEmpty(file) && !IsEmpty(format)) {
      if (format === 'image') {
        if (!this.imageFormats.includes(file.type)) {
          toast.error('Only JPG, JPEG and PNG files are supported.');
          return false;
        }

        if (file.size > this.maxFileSize) {
          toast.error('Maximum file size of 7MB exceeded.');
          return false;
        }
      } else {
        if (!this.docFormats.includes(file.type)) {
          toast.error('Only PDF is supported.');
          return false;
        }

        if (file.size > this.maxPDFFileSize) {
          toast.error('Maximum file size of 15MB exceeded.');
          return false;
        }
      }

      return true;
    }
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        {this.state.loading && <OverLoading />}

        <h5>Images</h5>
        <center>
          <DropzoneArea
            ref={(ref) => {
              this.dropZoneRef = ref;
            }}
            dropzoneText="Click to upload image"
            onChange={this.handleUpload.bind(this)}
            dropzoneClass={classes.myDropZone}
            showPreviewsInDropzone={false}
            showPreviews={false}
            showAlerts={false}
            clearOnUnmount
            getDropRejectMessage={(file) => this.handleErrorMessage(file, 'image')}
            filesLimit={15}
            maxFileSize={this.maxFileSize}
            acceptedFiles={['image/jpg', 'image/jpeg', 'image/png']}
          />
        </center>

        {this.state.images.length > 0
          ? (
            <Chip
              style={{
                backgroundColor: 'rgba(255,255,255,0)',
                width:           '150px',
                verticalAlign:   'bottom',
                margin:          '0px 0px -40px 35px',
              }}
              label={<Typography variant="h1">Cover Image</Typography>}
            />
          )
          : ''}

        {this.state.images.length > 0
          ? (
            <div style={{ position: 'relative' }}>
              <Chip style={{
                backgroundColor: '#c0c0c0',
                width:           '218px',
                height:          '218px',
                verticalAlign:   'bottom',
                margin:          '65px 0px -246px -5px',
              }}
              />

              {this.state.images
              && (
                <>
                  <SortableMedia
                    maxHt={200}
                    minHt={200}
                    maxWd={200}
                    minWd={200}
                    images={this.state.images}
                    pdf
                    handleCrop={this.handleCrop}
                    handleView={this.handleView}
                    handleDelete={(mediaData) => this.handleConfirmation(mediaData)}
                    handleUploadPdf={(data) => this.handleChange(data)}
                    handleDeletePdf={(data) => this.handleDeletePdf(data)}
                    handleSort={this.handleSort}
                    listItemMargin="25px 5px"
                  />

                  <input
                    type="file"
                    accept="application/pdf"
                    ref={this.hiddenFileInput}
                    onChange={(e) => { this.handlePDFUpload(e); e.target.value = ''; }}
                    style={{ display: 'none' }}
                  />
                </>
              )}

            </div>
          )
          : ''}

        {(this.props.showSaveImgPosBtn && this.state.images.length > 0 && this.state.isImagePosChanged)
          ? (
            <center>
              <div style={{ marginTop: 50 }}>
                <Button
                  style={{ marginLeft: 30 }}
                  variant="contained"
                  onClick={() => this.handleUpdate()}
                >
                  Save Image Position

                </Button>
              </div>
            </center>
          ) : ''}

        {this.state.view && (
          <Lightbox
            animationDisabled
            mainSrc={this.state.viewImage}
            onCloseRequest={() => {
              this.setState({
                view:      false,
                viewImage: null,
              });
            }}
          />
        )}

        { this.state.listOfFileImages.length > 0 && (
          this.state.listOfFileImages.map((image, i) => (
            <Dialog
              fullScreen
              open={this.state.imageDialogs[`file${i}`]}
              onClose={() => { this.handleCloseImageDialogs(i, image.name); }}
            >
              <FixedCropper
                width={4}
                height={3}
                cropPixelWidth={400}
                cropPixelHeight={400}
                outputPixelWidth={900}
                outputPixelHeight={900}
                type="upload"
                url={this.state.uploadUrl}
                src={this.state.listOfSrc[`file${i}`]}
                file={image}
                handleSave={this.handleSaveMultiple}
                index={i}
                handleClose={() => { this.handleCloseImageDialogs(`file${i}`, image.name); }}
                isCropping={this.state.cropping}
              />
            </Dialog>
          ))
        )}

        {
          Object.keys(this.state.openCropDialogs).map((dialog, index) => {
            const openCropDialogKeys = Object.keys(this.state.openCropDialogs);
            const desiredIndex = openCropDialogKeys.length - 1 - index;
            const dialogKey = `file${desiredIndex}`;

            return (
              <Dialog
                key={dialogKey}
                fullScreen
                open={this.state.openCropDialogs[dialogKey]}
                onClose={() => { this.handleCloseOpenCropDialogs(); }}
              >
                <FixedCropper
                  width={4}
                  height={3}
                  cropPixelWidth={400}
                  cropPixelHeight={400}
                  outputPixelWidth={900}
                  outputPixelHeight={900}
                  type={this.state.type}
                  url={this.state.uploadUrls[dialogKey]}
                  src={this.state.listOfSrc[dialogKey]}
                  file={this.state.currentFile}
                  handleSave={this.handleSave}
                  index={desiredIndex}
                  handleClose={() => { this.handleCloseOpenCropDialogs(); }}
                  isCropping={this.state.cropping}
                />
              </Dialog>
            );
          })
        }

        {/* Cropper for upload file */}
        <Dialog
          fullScreen
          open={this.state.openCropDialog}
          onClose={() => { this.handleClose(); }}
        >
          <FixedCropper
            width={4}
            height={3}
            cropPixelWidth={400}
            cropPixelHeight={400}
            outputPixelWidth={900}
            outputPixelHeight={900}
            type={this.state.type}
            url={this.state.uploadUrl}
            src={this.state.src}
            file={this.state.currentFile}
            handleSave={this.handleSave}
            handleClose={this.handleClose}
            isCropping={this.state.cropping}
          />
        </Dialog>

        <Dialog
          fullWidth
          size="sm"
          open={this.state.alert}
          onClose={() => { this.handleClose(); }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Remove Image</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete the image?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { this.handleClose(); }} color="primary">Cancel</Button>
            <Button onClick={() => { this.handleDelete(); }} color="primary">Confirm</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

Photo.propTypes = {
  classes: PropTypes.shape(Object).isRequired,
  match:   PropTypes.shape({
    params: PropTypes.shape({
      pageId: PropTypes.string,
      postId: PropTypes.string,
    }),
  }).isRequired,
  showSaveImgPosBtn: PropTypes.bool,
  images:            PropTypes.arrayOf(PropTypes.shape(Object)),
  onSetPostImages:   PropTypes.func,
  onSort:            PropTypes.func,
};

Photo.defaultProps = {
  images:            [],
  showSaveImgPosBtn: true,
  onSetPostImages:   () => {},
  onSort:            () => {},
};

const mapDispatchToProps = () => ({});

export default connect(null, mapDispatchToProps)(withStyles(useStyles)(Photo));
